export default __webpack_public_path__ + "static/media/Reis Magos Fort.dbacd36c.jpeg";